import { Box, Text } from '@chakra-ui/react';
import { type User } from '@halo/chat-sdk-react';
import { Empty, UserItem } from '@halo/ui-chat-react';
import { Fragment } from 'react/jsx-runtime';
import { Checkmark } from '@halo/ui-react';

export type GroupedUsersList = {
  label?: React.ReactNode;
  items: any[];
};

interface GroupedUsersProps {
  list: GroupedUsersList[];
  toggleSelectUser: (user: User) => void;
  selected: User[];
  checkUserKey?: boolean;
}

const GroupedUsers = ({
  list,
  toggleSelectUser,
  selected,
  checkUserKey = true,
}: GroupedUsersProps) => {
  const isEmpty = list.every((item) => item.items.length === 0);
  return (
    <Box className="scrollHover" h="350px" overflowY="auto">
      {isEmpty && <Empty />}
      {list.map(({ label, items }, index) => {
        if (items?.length === 0) return null;
        return (
          <Fragment key={index}>
            {label && (
              <Text fontSize="xs" fontWeight="bold" p="2.5">
                {label}
              </Text>
            )}
            <Box>
              {items?.map((item) => {
                const isKeyErr = checkUserKey
                  ? !(item.have_group_key && item.have_user_key)
                  : false;
                const isChecked = selected.some((i) => i.user_id === item.user_id);
                const isDisabled = isKeyErr || item.disabled;

                const onClick = () => {
                  if (isDisabled) return;
                  toggleSelectUser(item);
                };

                return (
                  <UserItem
                    key={item.user_id}
                    {...item}
                    avatar={item.avatar}
                    error={isKeyErr}
                    startElement={
                      <Checkmark
                        filled
                        size="sm"
                        borderRadius="sm"
                        cursor={isDisabled ? 'not-allowed' : 'pointer'}
                        disabled={isDisabled}
                        onClick={onClick}
                        checked={isChecked || item.defaultChecked}
                      />
                    }
                    onClick={onClick}
                    cursor={isDisabled ? 'not-allowed' : 'pointer'}
                  />
                );
              })}
            </Box>
          </Fragment>
        );
      })}
    </Box>
  );
};

const MemoizedGroupedUsers = memo(GroupedUsers);

export { MemoizedGroupedUsers as GroupedUsers };
